import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import LoginPage from './pages/LoginPage';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router';
import ForecastPage from './pages/ForecastPage';
import PlantOverviewPage from './pages/PlantOverviewPage';
import AccountManagementPage from './pages/AccountManagementPage';
import './utils/i18n';
import { LoggerProvider } from './contexts/LoggerContext';
import { Provider } from 'react-redux';
import { setupStore } from './store';
import { NavermapsProvider } from 'react-naver-maps';
import { ErrorPage } from './pages/ErrorPage';
import { OperationSettlementPage } from './pages/OperationSettlementPage';
import { OperationManagementPage } from './pages/OperationManagementPage';
import InvoicePage from './pages/InvoicePage';
import OperationAnalysisPage from './pages/OperationAnalysisPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={setupStore()}>
      <NavermapsProvider ncpKeyId={process.env.REACT_APP_NCP_CLIENT_ID ?? ''}>
        <LoggerProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="forecast" element={<ForecastPage />} />
              <Route path="overview" element={<PlantOverviewPage />} />
              <Route
                path="account-management"
                element={<AccountManagementPage />}
              />
              <Route path="error" element={<ErrorPage />} />
              <Route path="operation">
                <Route
                  path="settlement"
                  element={<OperationSettlementPage />}
                />
                <Route
                  path="management"
                  element={<OperationManagementPage />}
                />
                <Route path="analysis" element={<OperationAnalysisPage />} />
              </Route>
              <Route path="invoice" element={<InvoicePage />} />
            </Routes>
          </BrowserRouter>
        </LoggerProvider>
      </NavermapsProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
